import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import SalonServices from '../json-pages/SalonServices';
import SalonPrimaryDialog from '../json-pages/SalonPrimaryDialog';

const UI = ({ match }) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Route path={`${match.url}/primary`} component={SalonPrimaryDialog} />
      <Route path={`${match.url}/services`} component={SalonServices} />
      <Redirect to="/error" />
    </Switch>
  </div>
);
export default UI;
